import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const WrongPathRedirect = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(15);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 15000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  return (
    <div className="wrongpath-wrapper">
      <div className="wrongpath-card">
        <div className="icon-circle">!</div>

        <h2 className="wrongpath-title">Page Not Found</h2>

        <p className="wrongpath-text">
          Looks like this page has moved or is no longer available.
        </p>

        <p className="wrongpath-text">
          We’ve recently updated our website, so some older links may not work
          anymore. You’ll be redirected to the homepage shortly.
        </p>

        <p className="wrongpath-count">
          Redirecting to homepage in <span>{count}</span> seconds...
        </p>

        <button className="wrongpath-button" onClick={() => navigate("/")}>
          Go to Homepage Now
        </button>
      </div>
    </div>
  );
};

export default WrongPathRedirect;
